export default {
  header: '{assetDisplayName} quick navigation',
};
